import { ReactComponent as HeartFilledSVG } from "@assets/icons/heart-filled.svg";
import { ReactComponent as HeartOutlinedSVG } from "@assets/icons/heart-outlined.svg";
import { ReactComponent as MessageFilledSVG } from "@assets/icons/message-filled.svg";
import { ReactComponent as MessageOutlinedSVG } from "@assets/icons/message-outlined.svg";
import { ReactComponent as SendFilledSVG } from "@assets/icons/send-filled.svg";
import { ReactComponent as SendOutlinedSVG } from "@assets/icons/send-outlined.svg";



export const HeartFilled = (props) => <HeartFilledSVG {...props} />;
export const HeartOutlined = (props) => <HeartOutlinedSVG />;
export const MessageFilled = (props) => <MessageFilledSVG {...props} />;
export const MessageOutlined = (props) => <MessageOutlinedSVG {...props} />;
export const SendFilled = (props) => <SendFilledSVG {...props} />;
export const SendOutlined = (props) => <SendOutlinedSVG {...props} />;